function Overlay({children}) {
    return (
        <div className="common-overlay">
            {children}
        </div>
    )
}

export default Overlay
